var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-overlay',{staticClass:"text-center",attrs:{"value":_vm.loading,"opacity":"0.75"}},[_c('v-progress-circular',{attrs:{"indeterminate":""}}),_c('p',[_vm._v(" "+_vm._s(_vm.$t('loading'))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }